import i18n from '@/plugins/i18n';

export const colors = [
  '#F7517F',
  '#28EFC9',
  '#8EBDFE',
  '#F1A4E0',
  '#FEFCAC',
  '#FFC260',
  '#FFD800',
  '#FFFF53',
  '#FDFCAC',
  '#FFFFFF',
  '#FF0080',
  '#F54AA0',
  '#FF96CB',
  '#FF0A0A',
  '#FF4A4A',
];

export const getColor = (index) => {
  if (index >= colors.length || index < 0) index = 0;
  return colors[index];
};

let capabilityLables = new Map();
capabilityLables.set('A', i18n.global.t('usage.APM'));
capabilityLables.set('B', i18n.global.t('browserMonitoring'));
capabilityLables.set('V', i18n.global.t('vmMonitoring'));
capabilityLables.set('D', i18n.global.t('databaseMonitoring'));
capabilityLables.set('M', i18n.global.t('mobileMonitoring'));
capabilityLables.set('W', i18n.global.t('web-server-monitoring'));
capabilityLables.set('S', i18n.global.t('syntheticMonitoring'));
capabilityLables.set('K', i18n.global.t('k8m'));
capabilityLables.set('Q', i18n.global.t('mq.mqMonitoring'));
capabilityLables.set('L', i18n.global.t('logMonitoring'));
capabilityLables.set('ANL', i18n.global.t('analyticsCap'));
capabilityLables.set('C', i18n.global.t('cloudSvc'));

export const getKey = (value) => {
  return [...capabilityLables].find(([key, val]) => key == value)[1];
};

export const capLabels = [
  i18n.global.t('browserMonitoring'),
  i18n.global.t('usage.APM'),
  // 'Browser Monitoring',
  i18n.global.t('databaseMonitoring'),
  i18n.global.t('vmMonitoring'),
  i18n.global.t('mobileMonitoring'),
  i18n.global.t('web-server-monitoring'),
  i18n.global.t('syntheticMonitoring'),
  i18n.global.t('k8m'),
  i18n.global.t('mq.mqMonitoring'),
  i18n.global.t('logMonitoring'),
  i18n.global.t('analyticsCap'),
  i18n.global.t('cloudSvc'),
];
export const TOP_APPS_RES_HEADERS = () => [
  {
    label: i18n.global.t('apps'),
    width: '100%',
    key: 'label',
    redirect: true,
    sortable: true,
    dataType: 'string',
  },
  {
    label: i18n.global.t('avg'),
    width: '20%',
    key: 'avg',
    sortable: true,
    dataType: 'number',
  },
  {
    label: i18n.global.t('max'),
    width: '20%',
    key: 'max',
    sortable: true,
    dataType: 'number',
  },
];

export const APDEX_APPLIST_TABS = () => [
  {
    routerName: 'home',
    name: i18n.global.t('apmLabel'),
    serviceType: 'APM',
  },
  {
    routerName: 'home',
    name: i18n.global.t('browserMonitoring'),
    serviceType: 'Browser',
  },
];

export const HEALTH_STATUSES = () => [
  { key: 'GOOD', label: i18n.global.t('good') },
  { key: 'FAIR', label: i18n.global.t('fair') },
  { key: 'POOR', label: i18n.global.t('poor') },
];

export const APDEX_APPLIST_HEADERS = () => [
  { name: i18n.global.t('applications'), key: 'serviceName', width: '55%' },
  { name: i18n.global.t('serviceApdex'), key: 'apdex', width: '20%' },
  {
    name: i18n.global.t('responseTime'),
    key: 'respTime',
    width: '25%',
    sortable: true,
  },
];

export const APDEX_THRESHOLDS = {
  Good: 0.84,
  Fair: 0.69,
};

export const DEFAULT_APP_LIST = {
  total: 0,
  records: [],
};

export const DEFAULT_PAGE = 1;
